import { useContext } from 'react';

import DragAndDropUploadContext from '../Components/DragAndDropUpload/Context';

export function useDragAndDropUpload() {
  return useContext(DragAndDropUploadContext);
}
